import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PricingCards from './components/PricingCards';
import FeatureTable from './components/FeatureTable';
import PricingFAQ from './components/PricingFAQ';

export default function Pricing() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main>
        <section className="pt-32 pb-16 text-center px-4">
          <span className="inline-block bg-primary-50 text-primary-600 text-xs font-semibold px-3 py-1 rounded-full tracking-wide uppercase mb-4">{t('pricing.hero_tag')}</span>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 mb-4">{t('pricing.hero_title')}</h1>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">{t('pricing.hero_subtitle')}</p>
        </section>
        <section className="pb-16 px-4 sm:px-6 lg:px-8">
          <PricingCards />
          <FeatureTable />
          <PricingFAQ />
        </section>
        <section className="gradient-hero py-20 mt-16">
          <div className="max-w-3xl mx-auto text-center px-4">
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-white mb-3">{t('pricing.cta_title')}</h2>
            <p className="text-white/60 mb-8">{t('pricing.cta_subtitle')}</p>
            <Link to="/support" className="inline-flex items-center gap-2 bg-white text-primary-600 hover:bg-primary-50 font-semibold px-8 py-3.5 rounded-full transition-all shadow-lg text-sm">
              {t('pricing.cta_btn')}
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
